import React, { useState, useEffect, useCallback } from 'react';
import { db } from '../../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import './FeaturedClients.css';

const SKELETON_COUNT = 4;

export default function FeaturedClients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(false);

  const loadClients = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const snap = await getDoc(doc(db, 'settings', 'homepage'));
      if (snap.exists()) {
        const data = snap.data();
        const allClients = data.featuredClients || [];
        setClients(allClients.filter(c => c.enabled !== false));
      }
    } catch (err) {
      console.error('Error loading featured clients:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadClients(); }, [loadClients]);

  /* ── Skeleton state ───────────────────────────────────────────────────── */
  if (loading) {
    return (
      <section className="fc-section">
        <div className="fc-inner">
          <p className="fc-eyebrow">Establishments</p>
          <h2 className="fc-heading">Featured Clients</h2>
          <div className="fc-skeleton-grid">
            {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
              <div key={i} className="fc-skeleton-card">
                <div className="fc-skeleton-image" />
                <div className="fc-skeleton-footer">
                  <div className="fc-skeleton-line" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  /* ── Error / offline state ────────────────────────────────────────────── */
  if (error) {
    return (
      <section className="fc-section">
        <div className="fc-inner">
          <p className="fc-eyebrow">Establishments</p>
          <h2 className="fc-heading">Featured Clients</h2>
          <div className="fc-error-state">
            <p className="fc-error-msg">Could not load clients. Check your connection.</p>
            <button className="fc-retry-btn" onClick={loadClients}>Try Again</button>
          </div>
        </div>
      </section>
    );
  }

  /* ── Empty / hidden ───────────────────────────────────────────────────── */
  if (clients.length === 0) return null;

  /* ── Normal render ────────────────────────────────────────────────────── */
  return (
    <section className="fc-section">
      <div className="fc-inner">
        <p className="fc-eyebrow">Establishments</p>
        <h2 className="fc-heading">Featured Clients</h2>
        <div className="fc-grid">
          {clients.map((item) => (
            <div className="fc-card" key={item.id}>
              <div className="fc-card-image-wrap">
                <img src={item.imageUrl} alt={item.title} className="fc-card-image" />
              </div>
              <div className="fc-card-footer">
                <h3 className="fc-card-title">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}